import React from 'react';
import classNames from 'classnames';

import VideoMediafilesPreviewItemSkeleton from 'application/components/VideoMediafilePreviewItemSkeleton';
import styles from './index.module.scss';
import ItemContent from '../ItemContent';
import { IVideoMediafile } from '../../types';

export type StreamPreviewItemProps = {
  file?: IVideoMediafile;
  className?: string;
  onSetDuration: (id: string, duration: number) => void;
  onRemoveMediafile: (id: string) => void;
  onCopyMediafile: (id: string) => void;
};

const PreviewItem: React.FC<StreamPreviewItemProps> = ({
  file,
  className,
  onSetDuration,
  onRemoveMediafile,
  onCopyMediafile,
}) => {
  const renderItem = () => {
    if (file) {
      return (
        <ItemContent
          imgLink={file.previewUrl}
          title={file.title}
          duration={file.duration}
          extension={file.sourcefiles ? file?.sourcefiles[0]?.extension : undefined}
          playDuration={file.playDuration}
          onSetDuration={onSetDuration}
          id={file.id}
          onRemoveMediafile={onRemoveMediafile}
          onCopyMediafile={onCopyMediafile}
        />
      );
    }

    return <VideoMediafilesPreviewItemSkeleton />;
  };

  return <div className={classNames(styles.StreamPreviewItem, className)}>{renderItem()}</div>;
};

export default PreviewItem;
